export const FNB_QUERY_KEYS = {
    fnbReviewList: (cstrShopNo: string) => ['fnb-review-list', cstrShopNo] as const,
} as const;
